export default __webpack_public_path__ + "static/media/dutgo-screenshot-06.36e129f5.png";